import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeader } from './SectionHeader';
import { AlertCircleIcon, HelpCircleIcon, ClockIcon, MessageCircleIcon, HeartCrackIcon, SchoolIcon, FileWarningIcon, WalletIcon } from 'lucide-react';
const painPoints = [{
  icon: AlertCircleIcon,
  title: 'Llegás sin saber por dónde empezar',
  desc: 'Sin protocolo claro para la primera sesión con cada paciente nuevo.'
}, {
  icon: HelpCircleIcon,
  title: 'No sabés qué test elegir',
  desc: 'Sin criterio definido para elegir entre TEPROSIF-R, PLON-R, TECAL o EDAF.'
}, {
  icon: ClockIcon,
  title: 'El informe te lleva horas',
  desc: 'Sin plantilla ni vocabulario clínico estructurado, cada informe es desde cero.'
}, {
  icon: MessageCircleIcon,
  title: 'Los padres te hacen preguntas difíciles',
  desc: 'No sabés cómo responder "¿es grave?" o "¿se va a curar?" sin improvisar.'
}, {
  icon: HeartCrackIcon,
  title: 'La devolución te genera ansiedad',
  desc: 'Sin protocolo para comunicar el diagnóstico con claridad y sin alarmar.'
}, {
  icon: SchoolIcon,
  title: 'Articulás mal con la escuela',
  desc: 'No sabés qué información darle a la maestra ni cómo hacerlo profesionalmente.'
}, {
  icon: FileWarningIcon,
  title: 'No tenés nada por escrito',
  desc: 'Sin acuerdo de inicio, sin política de cancelaciones, sin registro de sesión.'
}, {
  icon: WalletIcon,
  title: 'Fin de mes con números que no cierran',
  desc: 'Sin sistema de honorarios, cobrás de menos sin saberlo.'
}];
export function PainPoints() {
  return <section className="py-12 md:py-20 px-4 md:px-8 bg-cream" data-id="element-164">
      <div className="max-w-3xl mx-auto" data-id="element-165">
        <SectionHeader title="¿TE PASA ESTO?" subtitle="Si trabajás en consulta privada con niños en Argentina, esto te suena familiar:" className="mb-8 md:mb-12" data-id="element-166" />

        <div className="bg-white rounded-2xl md:rounded-3xl border border-slate-200 shadow-sm overflow-hidden divide-y divide-slate-100" data-id="element-167">
          {painPoints.map((point, index) => {
          const Icon = point.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            margin: '-30px'
          }} transition={{
            duration: 0.4,
            delay: index * 0.04
          }} className="group flex items-start gap-4 md:gap-5 p-4 md:p-5 hover:bg-cream/50 transition-colors" data-id="element-168">
                <div className="shrink-0 w-10 h-10 md:w-11 md:h-11 bg-terracotta/10 group-hover:bg-terracotta/15 rounded-xl flex items-center justify-center transition-colors" data-id="element-169">
                  <Icon className="text-terracotta" size={20} data-id="element-170" />
                </div>
                <div className="flex-grow min-w-0 pt-0.5" data-id="element-171">
                  <h3 className="font-bold text-teal-900 mb-0.5 md:mb-1 leading-tight text-sm md:text-base" data-id="element-172">
                    {point.title}
                  </h3>
                  <p className="text-xs md:text-sm text-slate-600 leading-relaxed" data-id="element-173">
                    {point.desc}
                  </p>
                </div>
              </motion.div>;
        })}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="text-center mt-8 md:mt-12" data-id="element-174">
          <h3 className="text-xl md:text-3xl font-serif font-bold text-teal-900 leading-tight" data-id="element-175">
            ¿Cuántos pacientes más vas a atender improvisando?
          </h3>
        </motion.div>
      </div>
    </section>;
}